import React from "react";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import App from "./App";
import { GlobalState } from "./middleware";
import { MenuState } from "./context/Menu/state";
const root = createRoot(document.getElementById("root"));
root.render(
  <GlobalState>
    <BrowserRouter>
      <MenuState>
        <App />
      </MenuState>
    </BrowserRouter>
  </GlobalState>
);
